import { render, staticRenderFns } from "./Cp58Statement.vue?vue&type=template&id=5a52fa00&"
import script from "./Cp58Statement.vue?vue&type=script&lang=js&"
export * from "./Cp58Statement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports